import { render, staticRenderFns } from "./contact-panel.vue?vue&type=template&id=0351ec06&scoped=true&"
import script from "./contact-panel.ts?vue&type=script&lang=ts&"
export * from "./contact-panel.ts?vue&type=script&lang=ts&"
import style0 from "./contact-panel.scss?vue&type=style&index=0&id=0351ec06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0351ec06",
  null
  
)

export default component.exports